import { CART_STEP, PAYMENT, PDP_STEP } from '../flowConstants';
import cartDependencySaga from '../../cart/cartDependencySagas';
import paymentDependencySaga from '../../payment/paymentDependencySaga';
import productDependencySaga from '../../giftCardDetailsPage_v2/productDependencySaga';



export const DEPENDENCY_CONFIG = {
    [CART_STEP]: cartDependencySaga,
    [PAYMENT]: paymentDependencySaga,
    [PDP_STEP]: productDependencySaga
};


export const RUN_DEPENDENCIES = '@@storefront/RUN_DEPENDENCIES';

export const runDependenciesAction = stepName => ({
    type: RUN_DEPENDENCIES,
    stepName
});
